export default "__VITE_ASSET__Ci$vWXea__"